import { render, staticRenderFns } from "./AddReservationStudentForm.vue?vue&type=template&id=7f53421e&"
import script from "./AddReservationStudentForm.vue?vue&type=script&lang=js&"
export * from "./AddReservationStudentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports